import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B04InventoryManagementPage } from '../b04-inventory-management/b04-inventory-management';
import { toBase64String } from '@angular/compiler/src/output/source_map';
import { stringify } from '@angular/core/src/render3/util';

/**
 * Generated class for the B04dInventoryLevelInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface branchInfo{
  BRANCH_ID: number;
  BRANCH_NAME: string;
}

interface inventoryInfo{
  INVENTORY_ID: number;
  ITEM_DESC: string;
}

@IonicPage()
@Component({
  selector: 'page-b04d-inventory-level-info',
  templateUrl: 'b04d-inventory-level-info.html',
})
export class B04dInventoryLevelInfoPage {

  private todo : FormGroup;
  loading: any;
  Status: any;
  inventoryArr: inventoryInfo[] = [];
  inventoryItems: inventoryInfo[] = [];
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];

  inventoryLevelData = {  /* INVENTORY_LEVEL_ID:'', */
                          BRANCH_ID:'',  INVENTORY_ID:'',
                          QUANTITY:'', VALUE:'',
  }
  INVENTORY_LEVEL_ID:any;
  INVENTORY_ID:any;
  INVENTORY_EDIT:any;
  INVENTORY_COST:any;
  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public loadingCtrl: LoadingController,
              public serviceapi: ServiceApiProvider, public alertCtrl : AlertController) {

    this.todo = this.formBuilder.group({
      branch: ['', Validators.required],
      inventory: ['', Validators.required],
      quantity: ['', Validators.required],
      value: ['', Validators.required],
    });

    this.INVENTORY_LEVEL_ID = this.navParams.get('paramID');        //inventory level ID
    this.INVENTORY_ID = this.navParams.get('paramInventoryID');     //inventory ID
    this.INVENTORY_EDIT = this.navParams.get('paramEdit');          //inventory edit quantity or other

    let tbl = ["INVENTORY_LEVEL"];
    let column = ["INVENTORY_LEVEL_ID"];
    let value = [this.INVENTORY_LEVEL_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"INVENTORY_LEVEL","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){

        let Records = result["Records"];
        this.inventoryLevelData.BRANCH_ID = Records[0]["BRANCH_ID"];
        this.inventoryLevelData.INVENTORY_ID = Records[0]["INVENTORY_ID"];
        this.inventoryLevelData.QUANTITY = Records[0]["QUANTITY"];
        this.inventoryLevelData.VALUE = Records[0]["VALUE"];
        console.log(this.inventoryLevelData);
        //find inventory
        let tbl = ["INVENTORY"];
        let column = ["BRANCH_ID"];
        let value = [this.inventoryLevelData.BRANCH_ID];
        
        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];
      
        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");

        this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {

          this.Status = result["Message"];
          if (this.Status == '1'){
            
            let Records = result["Records"];
            this.inventoryArr = Records;
            this.inventoryItems = this.inventoryArr;

            //find branch
            let tbl = ["All"];
            let column = ["All"];
            let value = ["All"];
            
            let tblkey = ["No"];
            let fktbl = ["No"];
            let fkkey = ["No"];
          
            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");

            this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
              this.loading.dismiss();
              this.Status = result["Message"];
              if (this.Status == '1'){
                
                let Records = result["Records"];
                this.branchArr = Records;
                this.branchItems = this.branchArr;
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
              }
            }, (err) => {
              this.errorMessage = "Loading Error. Please try again.";
              this.loading.dismiss();
            });
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B04dInventoryLevelInfoPage');
  }

  delete(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to delete this item? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
              
            this.showLoader();
            this.serviceapi.deletedata('INVENTORY_LEVEL', 'INVENTORY_LEVEL_ID', this.INVENTORY_LEVEL_ID).then((result) => {
          
              this.Status = result["Message"];
              if (this.Status == "1"){
                this.loading.dismiss();
                this.navCtrl.setRoot(B04InventoryManagementPage);
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }
            }, (err) => {
                this.errorMessage = "Loading Error. Please try again.";
                this.loading.dismiss();
            });
        
          }
        }
      ]
    });
    confirm.present();
  }
  onChangeBranch(data)
  {
   let val = this.branchItems.find(c => c["BRANCH_ID"] === data);
   let branch_id = val["BRANCH_ID"];
   this.inventoryItems = [];
   let tbl = ["INVENTORY"];
   let column = ["BRANCH_ID"];
   let value = [branch_id];

   let tblkey = ["No"];
   let fktbl = ["No"];
   let fkkey = ["No"];

   let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

   let mydata = Object.assign(jsonitem);
   let json_data = this.serviceapi.json_readdata(mydata,"1");


   this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
     
     this.Status = result["Message"];
     if (this.Status == '1'){
       
       let Records = result["Records"];
       this.inventoryArr = Records;
       this.inventoryItems = this.inventoryArr;
       
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });

   //this.supplier_type = val["TYPE"];
   //this.supplier_type_id  = val["SUPPLIER_TYPE_ID"];
  }
  update(){
    if (this.INVENTORY_EDIT == 2){            //if edit quantity

      let tbl = ["INVENTORY"];
      let column = ["INVENTORY_ID"];
      let value = [this.INVENTORY_ID];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];
    
      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader();
      this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {

        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.INVENTORY_COST = Records[0]["COST"];

          let calculation = parseFloat(this.inventoryLevelData.QUANTITY) * this.INVENTORY_COST;
          this.inventoryLevelData.VALUE = String(calculation);
          
          this.serviceapi.updatedata('INVENTORY_LEVEL', 'INVENTORY_LEVEL_ID', this.INVENTORY_LEVEL_ID, this.inventoryLevelData).then((result) => {
              
            this.Status = result["Message"];
            if (this.Status == "1"){
              this.loading.dismiss();
              this.navCtrl.setRoot(B04InventoryManagementPage);
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
              this.loading.dismiss();
            }
          }, (err) => {
              this.errorMessage = "Loading Error. Please try again.";
              this.loading.dismiss();
          });
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
    }
    else {
      this.showLoader();
      this.serviceapi.updatedata('INVENTORY_LEVEL', 'INVENTORY_LEVEL_ID', this.INVENTORY_LEVEL_ID, this.inventoryLevelData).then((result) => {
          
        this.Status = result["Message"];
        if (this.Status == "1"){
          this.loading.dismiss();
          this.navCtrl.setRoot(B04InventoryManagementPage);
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
      });
    }
    
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B04InventoryManagementPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b04d-inventory-level-info/b04d-inventory-level-info.ts